import { UniversityUpdateRequest } from './UniversityUpdateRequest';

export interface UniversityCreateRequest
  extends UniversityUpdateRequest {
  translationKey: string;
}
